var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('v-btn',{staticClass:"ma-1",style:(_vm.theme),attrs:{"fab":"","title":_vm.title,"x-small":""},on:{"click":function($event){return _vm.onClick()}}},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }